export { default } from "../extends/_index.mjs"


//////////////////
// WEBPACK FOOTER
// /Users/cjcenizal/Documents/GitHub/Mine/flexbox-patterns-site/node_modules/@babel/runtime/helpers/esm/extends.js
// module id = 111
// module chunks = 0